<script setup>
import ContentCenter from '@/layouts/ContentCenter.vue'
import LoadingBar from './LoadingBar.vue'
</script>

<template>
  <ContentCenter class="bg-black">
    <template #center>
      <div class="md:w-5/12 w-80 ml-5">
        <div class="xp-logo-text text-white">
          <span class="xp-logo-name">Braxton F.</span>
          <span class="xp-logo-portfolio"><span class="xp-white">e</span><span class="xp-red">P</span><span class="xp-green">o</span><span class="xp-blue">r</span><span class="xp-yellow">t</span><span class="xp-red">f</span><span class="xp-green">o</span><span class="xp-blue">l</span><span class="xp-yellow">i</span><span class="xp-red">o</span></span>
        </div>
      </div>
    </template>

    <template #bottom-center>
      <LoadingBar />
    </template>

    <template #bottom>
      <div class="app-container absolute bottom-0 md:my-16 my-8">
        <div>
          <div class="flex justify-between items-center gap-8 text-white">
            <div>
              <h1 class="md:text-xl text-sm">{{ $t('message.welcome') }}</h1>
            </div>
            <div>
              <h2 class="md:text-2xl text-md tracking-tighter font-helvetica font-semibold">Braxton Freeman</h2>
            </div>
          </div>
        </div>
      </div>
    </template>
  </ContentCenter>
</template>

<style scoped>
.xp-logo-text {
  font-family: 'Franklin Gothic Medium', 'Trebuchet MS', Arial, sans-serif;
  font-weight: bold;
  font-style: italic;
  letter-spacing: -0.02em;
  display: flex;
  flex-direction: column;
}

.xp-logo-name {
  font-size: 1.5rem;
  background: linear-gradient(180deg, #fff 0%, #d4d4d4 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.xp-logo-portfolio {
  font-size: 3rem;
  line-height: 1;
}

.xp-red {
  color: #EA5514;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
}

.xp-green {
  color: #7FBA00;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
}

.xp-blue {
  color: #00A4EF;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
}

.xp-yellow {
  color: #FFB900;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
}

.xp-white {
  color: #FFFFFF;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
}

@media (min-width: 768px) {
  .xp-logo-name {
    font-size: 2rem;
  }
  .xp-logo-portfolio {
    font-size: 4.5rem;
  }
}
</style>
